import { IonButton, IonContent, IonIcon, IonPage, IonText } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Controller, Pagination, Zoom } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import Toolbar2 from '../../layouts/Toolbar2';

import { downloadOutline } from 'ionicons/icons';
import 'swiper/modules/controller/controller.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/zoom/zoom.min.css';
import 'swiper/swiper.min.css';
import './Gallery.css';
import { passToWebView } from '../../library/Funcs';

const Gallery: React.FC = () => {
    const history = useHistory();
    const [activeIdx, setActiveIdx] = useState(0);
    const [state, setState] = useState(null as any);
    const [download, setDownload] = useState(false);

    useEffect(() => {
        const s = history.location.state as any;
        setState(s);
        setActiveIdx(s.index);
        setDownload(s.download);
    }, []);

    const downloadButton = <IonButton onClick={() => downloadHandler()} shape="round">
        <IonIcon icon={downloadOutline} />
    </IonButton>

    const downloadHandler = () => {
        const file = state.images[activeIdx];
        passToWebView("sendPayment", file.download!);
    }

    return <IonPage className='gallery'>
        <Toolbar2 title="" endButtons={download && downloadButton} hasBackButton transparent />

        <IonContent>
            {state != null &&
                <Swiper
                    modules={[Controller, Pagination, Zoom]}
                    initialSlide={state.index!}
                    pagination={{ clickable: true }}
                    onSlideChange={(item) => setActiveIdx(item.realIndex)}
                    zoom={true}
                    dir="ltr">
                    {
                        state.images?.map((item: any) => {
                            const isVideo = item.url.toLowerCase().split('?')[0].endsWith('.mp4')
                            return <SwiperSlide zoom>
                                {isVideo ? (
                                    <video src={item.url} controls />
                                ) : (
                                    <img src={item.url} />
                                )}
                            </SwiperSlide>
                        })
                    }
                </Swiper>
            }
        </IonContent>
    </IonPage>
}

export default Gallery